import NiceModal from '@ebay/nice-modal-react';

import { Trans, useTranslation } from 'react-i18next';

import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

export default NiceModal.create(({ modalName, textKey = 'privacyPolicyText' }) => (
	<Modal name={modalName} fullwidth maxWidth="medium" className="modal-privacyPolicy">
		<ModalTitle></ModalTitle>
		<ModalContent>
			<Typography noWrap>
				<Trans
					i18nKey={textKey}
					components={{
						linkViewer: <LinkViewer />,
						ul: <Ul />,
						li: <Li />,
						span: <Span />
					}}
				/>
			</Typography>
		</ModalContent>
	</Modal>
));

const LinkViewer = ({ children }) => {
	const { t } = useTranslation();
	return <a href={children}>{t(children)}</a>;
};

const Span = ({ children }) => <span>{children}</span>;
const Ul = ({ children }) => <ul>{children}</ul>;
const Li = ({ children }) => <li>{children}</li>;
